export default __webpack_public_path__ + "static/media/signup.8f1d7716.png";